const Recharge = () => import('js/pages/recharge/index.js')
const News = () => import('js/pages/news')
const DownloadableResources = () => import('js/pages/downloadable-resources')
const PrePurchaseFares = () => import('js/pages/pre-purchase-fares')
const Renting = () => import('js/pages/renting')
const Advertising = () => import('js/pages/advertising')
const MovementsHistory = () => import('js/pages/movements-history')
const Claims = () => import('js/pages/claims')
const CookiesPolicy = () => import('js/pages/cookies-policy')
const InstitutionalInformation = () => import('js/pages/institutional-information')
const PrivacyPolicy = () => import('js/pages/privacy-policy')
const TransportRequest = () => import('js/pages/transport-request')
const PrivacidadePolicy = () => import('js/pages/privacidade-policy')

const meta = {
  layoutInfo: true
}

export default [
  {
    path: 'recharge',
    name: 'municipality-recharge',
    component: Recharge,
    meta
  },
  {
    path: ':media_code/:media_type/recharge',
    name: 'municipality-recharge-data',
    component: Recharge,
    meta
  },
  {
    path: 'news/:slug?',
    name: 'municipality-news',
    component: News,
    meta
  },
  {
    path: 'fares',
    name: 'municipality-fares',
    component: DownloadableResources,
    props: {type: 'fares'},
    meta
  },
  {
    path: 'schedules',
    name: 'municipality-schedules',
    component: DownloadableResources,
    props: {type: 'schedules'},
    meta
  },
  {
    path: 'pre-purchase-fares',
    name: 'municipality-pre-purchase-fares',
    component: PrePurchaseFares,
    meta
  },
  {
    path: 'renting',
    name: 'renting',
    component: Renting,
    meta
  },
  {
    path: 'advertising',
    name: 'advertising',
    component: Advertising,
    meta
  },
  {
    path: 'movements-history',
    name: 'municipality-movements-history',
    component: MovementsHistory,
    meta
  },
  {
    path: 'claims',
    name: 'claims',
    component: Claims,
    meta
  },
  {
    path: 'cookies-policy',
    name: 'cookies-policy',
    component: CookiesPolicy,
    meta
  },
  {
    path: 'institutional-information',
    name: 'institutional-information',
    component: InstitutionalInformation,
    meta
  },
  {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
    meta
  },
  {
    path: 'transport-request',
    name: 'transport-request',
    component: TransportRequest,
    meta
  }, 
  {
    path: 'privacidade-policy',
    name: 'privacidade-policy',
    component: PrivacidadePolicy,
    meta
  },
]
